import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResourcesPageHeaderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ResourcesPageHeaderQuery = { __typename?: 'Query', Resources: { __typename?: 'LibraryItems', totalCount: number } };

export type CreateBlankRichTextDocumentMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateBlankRichTextDocumentMutation = { __typename?: 'Mutation', createTrainingResourceV2: { __typename?: 'TrainingResourceMutationResult', trainingResource?: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string } } | null } };


export const ResourcesPageHeaderDocument = gql`
    query ResourcesPageHeader {
  Resources: AdminLibrary(
    input: {filters: {itemType: {value: TRAINING_RESOURCE}}}
  ) {
    totalCount
  }
}
    `;

/**
 * __useResourcesPageHeaderQuery__
 *
 * To run a query within a React component, call `useResourcesPageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesPageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesPageHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useResourcesPageHeaderQuery(baseOptions?: Apollo.QueryHookOptions<ResourcesPageHeaderQuery, ResourcesPageHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesPageHeaderQuery, ResourcesPageHeaderQueryVariables>(ResourcesPageHeaderDocument, options);
      }
export function useResourcesPageHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesPageHeaderQuery, ResourcesPageHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesPageHeaderQuery, ResourcesPageHeaderQueryVariables>(ResourcesPageHeaderDocument, options);
        }
export type ResourcesPageHeaderQueryHookResult = ReturnType<typeof useResourcesPageHeaderQuery>;
export type ResourcesPageHeaderLazyQueryHookResult = ReturnType<typeof useResourcesPageHeaderLazyQuery>;
export type ResourcesPageHeaderQueryResult = Apollo.QueryResult<ResourcesPageHeaderQuery, ResourcesPageHeaderQueryVariables>;
export const CreateBlankRichTextDocumentDocument = gql`
    mutation createBlankRichTextDocument {
  createTrainingResourceV2(
    input: {name: {en: ""}, richTextDocumentInput: {content: {en: ""}}}
  ) {
    trainingResource {
      id
      libraryItem {
        id
      }
    }
  }
}
    `;
export type CreateBlankRichTextDocumentMutationFn = Apollo.MutationFunction<CreateBlankRichTextDocumentMutation, CreateBlankRichTextDocumentMutationVariables>;

/**
 * __useCreateBlankRichTextDocumentMutation__
 *
 * To run a mutation, you first call `useCreateBlankRichTextDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankRichTextDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankRichTextDocumentMutation, { data, loading, error }] = useCreateBlankRichTextDocumentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateBlankRichTextDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlankRichTextDocumentMutation, CreateBlankRichTextDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlankRichTextDocumentMutation, CreateBlankRichTextDocumentMutationVariables>(CreateBlankRichTextDocumentDocument, options);
      }
export type CreateBlankRichTextDocumentMutationHookResult = ReturnType<typeof useCreateBlankRichTextDocumentMutation>;
export type CreateBlankRichTextDocumentMutationResult = Apollo.MutationResult<CreateBlankRichTextDocumentMutation>;
export type CreateBlankRichTextDocumentMutationOptions = Apollo.BaseMutationOptions<CreateBlankRichTextDocumentMutation, CreateBlankRichTextDocumentMutationVariables>;